import { usePageCrumbs } from './use-page-crumbs';
import type { Crumb } from './use-breadcrumbs';

/**
 * Publishes a page's breadcrumb trail to the top bar, from inside the shell
 * (the crumbs context lives in AppShell, so the hook cannot be called from the
 * component that renders DashboardLayout itself). The trail belongs in the top
 * bar: a second trail drawn inside the page repeated it 60px lower.
 */
export function PageCrumbs({ crumbs }: { crumbs: Crumb[] }) {
  usePageCrumbs(crumbs);
  return null;
}
